import { useState } from "react";
import api, { getToken } from "@/lib/api";
import { Upload, Check, Loader2, Camera } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fileSrc(fileId) {
  return fileId ? `${BACKEND}/api/files/${fileId}?auth=${getToken()}` : null;
}

export function AuthImage({ fileId, className, alt = "" }) {
  if (!fileId) return null;
  return <img src={fileSrc(fileId)} alt={alt} className={className} loading="lazy" />;
}

/** Uploads to operator file storage; calls onChange(fileId) on success. */
export function FileUpload({ label, category = "doc", value, onChange, testid, accept = "image/*", capture }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f); fd.append("category", category);
    try {
      const { data } = await api.post("/operator/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.id);
    } catch (err) { toast.error("Upload failed"); } finally { setBusy(false); }
  };
  return (
    <label data-testid={testid} className="flex cursor-pointer flex-col items-center justify-center gap-1.5 rounded-tenant-button border border-dashed border-tenant-border bg-tenant-bg px-3 py-4 text-center text-xs transition-colors hover:border-tenant-primary/50">
      {value ? (
        <span className="flex items-center gap-1.5 font-medium text-status-available"><Check className="h-4 w-4" /> {label} uploaded</span>
      ) : busy ? (
        <span className="flex items-center gap-1.5 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Uploading…</span>
      ) : (
        <span className="flex items-center gap-1.5 text-muted-foreground">{capture ? <Camera className="h-4 w-4" /> : <Upload className="h-4 w-4" />} {label}</span>
      )}
      <input type="file" accept={accept} capture={capture} className="hidden" onChange={upload} />
    </label>
  );
}
